import { call, put, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  GET_PATIENT_STEPS_REQUEST,
  GET_PATIENT_STEPS_SUCCESS,
  GET_PATIENT_STEPS_ERROR
} from "../../actions";

function* workerGetPatientStepsSaga({
  type,
  payload: { patientId, startDate, endDate },
}: {
  type: string;
  payload: {
    patientId: any;
    startDate: string;
    endDate: string;
  };
}): Generator<any> {
  try {
    const data: any = yield call(PatientsAPI.getPatientSteps, patientId, startDate, endDate);

    yield put({
      type: GET_PATIENT_STEPS_SUCCESS,
      payload: { steps: data }
    });
  } catch (error: any) {
    yield put({
      type: GET_PATIENT_STEPS_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
  }
}

export function* watcherGetPatientStepsSaga() {
  yield takeLatest(GET_PATIENT_STEPS_REQUEST, workerGetPatientStepsSaga);
}
